import React from 'react';
import _ from 'lodash';

// import {
//   Row,
//   Col,
// } from 'react-bootstrap';
// import styled from 'styled-components';

import { Alert } from 'antd';

// import { useAuthContext } from '../../../../../../auth/use-auth-context.js';

// Redux
// import { useDispatch } from 'react-redux';
// import { RootState, AppDispatch, useTypedSelector } from '../../../../../utils/store.tsx';
// import slice from './slice.tsx';

import { dinamicZoom, convertCoordToLatLng, getDefLatLngZoomV4 } from '../../../../../v5/utils/utils.tsx';
// import {  } from '../../../../../v5/utils/enums.tsx';

import GoogleMap, { addMarker, clearAllMarkers, routeMarkerSVGIcon } from '../../../../../v5/components/googleMap/GoogleMap.jsx';

import { ReactComponent as InfoIcon } from "../../../../../v5/assets/icons/alert-info.svg";

// ----------------------------------------------------------------------

const MapComponent = ({ coordinates, canMoveMarker, onDragEnd }: any) => {
  const defaultLatLngZoom: any = getDefLatLngZoomV4();

  // const {  } = useTypedSelector((state: RootState) => state.customersSiteChangeLocationSlice);
  // const dispatch = useDispatch<AppDispatch>();

  const [map, setMap] = React.useState<any>(null);

  const markersRef = React.useRef<Array<google.maps.Marker>>([]);

  let initCustomElements = [
    {
      element: 'span',
      text: '',
      className: '',
      style: {
        position: 'absolute',
        bottom: '25px',
        left: '10px',
      },
      visible: true,
      disabled: false,
      callback: null,
    }
  ];
  const [customElements, setCustomElements] = React.useState<Array<any>>(initCustomElements);


  React.useEffect(() => {
    clearAllMarkers(markersRef);
    
    if(coordinates != undefined && coordinates != ''){
      let position = convertCoordToLatLng(coordinates);
  
      addMarker(markersRef, {
        map: map,
        draggable: canMoveMarker,
        position: position,
        title: 'Test',
        // label: 'Desc',
        icon: {
          url: 'data:image/svg+xml;utf-8,' + routeMarkerSVGIcon('#CB3A31', ''),
          scaledSize: new google.maps.Size(26, 32),
          labelOrigin: new google.maps.Point(13, 41),
        },
        
        // label: {
        //   text: 'Test',
        //   className: 'marker-label'
        // },
      });
      
      if(markersRef && markersRef.current && markersRef.current.length > 0){
        let marker = markersRef.current[0];
  
        marker.addListener('dragend', (event: any) => {
          let pos = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };

          if(onDragEnd){
            onDragEnd(pos);
          }
        });

        if (marker && typeof marker.getPosition === 'function') {
          const position = marker.getPosition();
          if (position) {
            dinamicZoom(map, position.lat(), position.lng(), 0.0010);
          }
        } 
      }
    }
  }, [map]);

  React.useEffect(() => {
    clearAllMarkers(markersRef);
    
    if(coordinates != undefined && coordinates != ''){
      let position = convertCoordToLatLng(coordinates);
  
      addMarker(markersRef, {
        map: map,
        draggable: canMoveMarker,
        position: position,
        title: 'Test',
        // label: 'Desc',
        icon: {
          url: 'data:image/svg+xml;utf-8,' + routeMarkerSVGIcon('#CB3A31', ''),
          scaledSize: new google.maps.Size(26, 32),
          labelOrigin: new google.maps.Point(13, 41),
        },
        
        // label: {
        //   text: 'Test',
        //   className: 'marker-label'
        // },
      });
      
      if(markersRef && markersRef.current && markersRef.current.length > 0){
        let marker = markersRef.current[0];
  
        marker.addListener('dragend', (event: any) => {
          let pos = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };

          if(onDragEnd){
            onDragEnd(pos);
          }
        });

        if (marker && typeof marker.getPosition === 'function') {
          const position = marker.getPosition();
          if (position) {
            dinamicZoom(map, position.lat(), position.lng(), 0.0010);
          }
        } 
      }
    }

    let items = _.cloneDeep(initCustomElements);
    items[0].text = coordinates;
    items[0].className = (coordinates != undefined && coordinates != '') ? 'badge bg-custom-light btn-lg' : '';
    setCustomElements(items);
  }, [coordinates]);


  return <>
    {(coordinates != undefined && coordinates != '') && <div className='mb-8'>
      <Alert
        message=""
        description="You can adjust the position of the marker by dragging it. The coordinates will change but the rest of the fields will stay the same."
        type="info"
        showIcon
        icon={<InfoIcon />}
      />
    </div>}

    <div style={{ height: '300px', borderRadius: '6px', overflow: 'hidden', border: '1px solid var(--bs-gray-300)' }}>
      <GoogleMap
        canConextMenu={false}
        options={{
          center: defaultLatLngZoom.coord,
          zoom: defaultLatLngZoom.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          gestureHandling: "cooperative",
          zoomControl: false,
          cameraControl: false,
        }}
        customElements={customElements}
        onLoad={(map: any, ref: any) => {
          setMap(map);
        }}
      />
    </div>
  </>
}

export default MapComponent;
